<script lang="ts">let { color = "#fff", width = "4px", duration = ".5s" } = $props();
</script>

<div
	class="loader"
	style="--loader-color: {color}; --loader-width: {width}; --loader-duration: {duration};"
></div>

<style>
	.loader {
		width: var(--loader-width);
		aspect-ratio: 1;
		border-radius: 50%;
		color: var(--loader-color);
		box-shadow:
			19px 0 0 5px,
			38px 0 0 2px,
			57px 0 0 0;
		transform: scale(0.7);
		animation: dots-loader var(--loader-duration) infinite alternate linear;
	}

	@keyframes dots-loader {
		50% {
			box-shadow:
				19px 0 0 2px,
				38px 0 0 5px,
				57px 0 0 2px;
		}
		100% {
			box-shadow:
				19px 0 0 0,
				38px 0 0 2px,
				57px 0 0 5px;
		}
	}
</style>
